import { useDroppable } from "@dnd-kit/core";
import type { ReactNode } from "react";
import { cx } from "@/utils/cx";
import { FORM_BUILDER_DROP_ROOT } from "../../lib/form-builder-drop-target";

export function FormBuilderRootDropArea({
	children,
	"aria-label": ariaLabel,
}: {
	children: ReactNode;
	"aria-label": string;
}) {
	const { setNodeRef, isOver } = useDroppable({ id: FORM_BUILDER_DROP_ROOT });
	return (
		<section
			ref={setNodeRef}
			aria-label={ariaLabel}
			className={cx(
				"min-h-form-builder-drop-zone flex-1",
				isOver && "bg-brand-50/50 ring-1 ring-brand-500/30",
			)}
		>
			{children}
		</section>
	);
}
